module.exports = __webpack_public_path__ + "static/media/1_01.f0713175.jpg";